"use client";
import * as React from 'react';

type Props = React.InputHTMLAttributes<HTMLInputElement>;

export function Checkbox({ className = '', ...rest }: Props) {
  const cls = ['admin-checkbox', className].filter(Boolean).join(' ');
  return <input type="checkbox" className={cls} {...rest} />;
}

export default Checkbox;

